import EmployeeNav from "../components/user/employees/EmployeeNav";
import Title from "../utils/Title";
import AppWrapper from "./AppWrapper";

function EmployeesWrapper({ children, title }) {

  return (
    <>
      <AppWrapper
        pagename={"staff"}
      >
        <Title title={title} btnName={""} />
        {children}

        <EmployeeNav />

      </AppWrapper>

    </>
  );
}

export default EmployeesWrapper;
